/**
 * Frozen Unicode 3.2 tables from RFC 3454, generated from the vendored
 * `docs/rfc/rfc3454.txt`. RFC 4518 §2.1 fixes string preparation to the Unicode
 * 3.2 repertoire, so these tables must not track the running Unicode version.
 *
 * Do not edit by hand; regenerate from the vendored RFC.
 *
 * @module
 */

/** Inclusive `[first, last]` code-point ranges. */
export type CodePointRange = readonly [number, number];

/** RFC 3454 Table A.1: code points unassigned in Unicode 3.2 (Prohibit). */
export const A1_UNASSIGNED_RANGES: readonly CodePointRange[] = [
	[0x221, 0x221],
	[0x234, 0x24f],
	[0x2ae, 0x2af],
	[0x2ef, 0x2ff],
	[0x350, 0x35f],
	[0x370, 0x373],
	[0x376, 0x379],
	[0x37b, 0x37d],
	[0x37f, 0x383],
	[0x38b, 0x38b],
	[0x38d, 0x38d],
	[0x3a2, 0x3a2],
	[0x3cf, 0x3cf],
	[0x3f7, 0x3ff],
	[0x487, 0x487],
	[0x4cf, 0x4cf],
	[0x4f6, 0x4f7],
	[0x4fa, 0x4ff],
	[0x510, 0x530],
	[0x557, 0x558],
	[0x560, 0x560],
	[0x588, 0x588],
	[0x58b, 0x590],
	[0x5a2, 0x5a2],
	[0x5ba, 0x5ba],
	[0x5c5, 0x5cf],
	[0x5eb, 0x5ef],
	[0x5f5, 0x60b],
	[0x60d, 0x61a],
	[0x61c, 0x61e],
	[0x620, 0x620],
	[0x63b, 0x63f],
	[0x656, 0x65f],
	[0x6ee, 0x6ef],
	[0x6ff, 0x6ff],
	[0x70e, 0x70e],
	[0x72d, 0x72f],
	[0x74b, 0x77f],
	[0x7b2, 0x900],
	[0x904, 0x904],
	[0x93a, 0x93b],
	[0x94e, 0x94f],
	[0x955, 0x957],
	[0x971, 0x980],
	[0x984, 0x984],
	[0x98d, 0x98e],
	[0x991, 0x992],
	[0x9a9, 0x9a9],
	[0x9b1, 0x9b1],
	[0x9b3, 0x9b5],
	[0x9ba, 0x9bb],
	[0x9bd, 0x9bd],
	[0x9c5, 0x9c6],
	[0x9c9, 0x9ca],
	[0x9ce, 0x9d6],
	[0x9d8, 0x9db],
	[0x9de, 0x9de],
	[0x9e4, 0x9e5],
	[0x9fb, 0xa01],
	[0xa03, 0xa04],
	[0xa0b, 0xa0e],
	[0xa11, 0xa12],
	[0xa29, 0xa29],
	[0xa31, 0xa31],
	[0xa34, 0xa34],
	[0xa37, 0xa37],
	[0xa3a, 0xa3b],
	[0xa3d, 0xa3d],
	[0xa43, 0xa46],
	[0xa49, 0xa4a],
	[0xa4e, 0xa58],
	[0xa5d, 0xa5d],
	[0xa5f, 0xa65],
	[0xa75, 0xa80],
	[0xa84, 0xa84],
	[0xa8c, 0xa8c],
	[0xa8e, 0xa8e],
	[0xa92, 0xa92],
	[0xaa9, 0xaa9],
	[0xab1, 0xab1],
	[0xab4, 0xab4],
	[0xaba, 0xabb],
	[0xac6, 0xac6],
	[0xaca, 0xaca],
	[0xace, 0xacf],
	[0xad1, 0xadf],
	[0xae1, 0xae5],
	[0xaf0, 0xb00],
	[0xb04, 0xb04],
	[0xb0d, 0xb0e],
	[0xb11, 0xb12],
	[0xb29, 0xb29],
	[0xb31, 0xb31],
	[0xb34, 0xb35],
	[0xb3a, 0xb3b],
	[0xb44, 0xb46],
	[0xb49, 0xb4a],
	[0xb4e, 0xb55],
	[0xb58, 0xb5b],
	[0xb5e, 0xb5e],
	[0xb62, 0xb65],
	[0xb71, 0xb81],
	[0xb84, 0xb84],
	[0xb8b, 0xb8d],
	[0xb91, 0xb91],
	[0xb96, 0xb98],
	[0xb9b, 0xb9b],
	[0xb9d, 0xb9d],
	[0xba0, 0xba2],
	[0xba5, 0xba7],
	[0xbab, 0xbad],
	[0xbb6, 0xbb6],
	[0xbba, 0xbbd],
	[0xbc3, 0xbc5],
	[0xbc9, 0xbc9],
	[0xbce, 0xbd6],
	[0xbd8, 0xbe6],
	[0xbf3, 0xc00],
	[0xc04, 0xc04],
	[0xc0d, 0xc0d],
	[0xc11, 0xc11],
	[0xc29, 0xc29],
	[0xc34, 0xc34],
	[0xc3a, 0xc3d],
	[0xc45, 0xc45],
	[0xc49, 0xc49],
	[0xc4e, 0xc54],
	[0xc57, 0xc5f],
	[0xc62, 0xc65],
	[0xc70, 0xc81],
	[0xc84, 0xc84],
	[0xc8d, 0xc8d],
	[0xc91, 0xc91],
	[0xca9, 0xca9],
	[0xcb4, 0xcb4],
	[0xcba, 0xcbd],
	[0xcc5, 0xcc5],
	[0xcc9, 0xcc9],
	[0xcce, 0xcd4],
	[0xcd7, 0xcdd],
	[0xcdf, 0xcdf],
	[0xce2, 0xce5],
	[0xcf0, 0xd01],
	[0xd04, 0xd04],
	[0xd0d, 0xd0d],
	[0xd11, 0xd11],
	[0xd29, 0xd29],
	[0xd3a, 0xd3d],
	[0xd44, 0xd45],
	[0xd49, 0xd49],
	[0xd4e, 0xd56],
	[0xd58, 0xd5f],
	[0xd62, 0xd65],
	[0xd70, 0xd81],
	[0xd84, 0xd84],
	[0xd97, 0xd99],
	[0xdb2, 0xdb2],
	[0xdbc, 0xdbc],
	[0xdbe, 0xdbf],
	[0xdc7, 0xdc9],
	[0xdcb, 0xdce],
	[0xdd5, 0xdd5],
	[0xdd7, 0xdd7],
	[0xde0, 0xdf1],
	[0xdf5, 0xe00],
	[0xe3b, 0xe3e],
	[0xe5c, 0xe80],
	[0xe83, 0xe83],
	[0xe85, 0xe86],
	[0xe89, 0xe89],
	[0xe8b, 0xe8c],
	[0xe8e, 0xe93],
	[0xe98, 0xe98],
	[0xea0, 0xea0],
	[0xea4, 0xea4],
	[0xea6, 0xea6],
	[0xea8, 0xea9],
	[0xeac, 0xeac],
	[0xeba, 0xeba],
	[0xebe, 0xebf],
	[0xec5, 0xec5],
	[0xec7, 0xec7],
	[0xece, 0xecf],
	[0xeda, 0xedb],
	[0xede, 0xeff],
	[0xf48, 0xf48],
	[0xf6b, 0xf70],
	[0xf8c, 0xf8f],
	[0xf98, 0xf98],
	[0xfbd, 0xfbd],
	[0xfcd, 0xfce],
	[0xfd0, 0xfff],
	[0x1022, 0x1022],
	[0x1028, 0x1028],
	[0x102b, 0x102b],
	[0x1033, 0x1035],
	[0x103a, 0x103f],
	[0x105a, 0x109f],
	[0x10c6, 0x10cf],
	[0x10f9, 0x10fa],
	[0x10fc, 0x10ff],
	[0x115a, 0x115e],
	[0x11a3, 0x11a7],
	[0x11fa, 0x11ff],
	[0x1207, 0x1207],
	[0x1247, 0x1247],
	[0x1249, 0x1249],
	[0x124e, 0x124f],
	[0x1257, 0x1257],
	[0x1259, 0x1259],
	[0x125e, 0x125f],
	[0x1287, 0x1287],
	[0x1289, 0x1289],
	[0x128e, 0x128f],
	[0x12af, 0x12af],
	[0x12b1, 0x12b1],
	[0x12b6, 0x12b7],
	[0x12bf, 0x12bf],
	[0x12c1, 0x12c1],
	[0x12c6, 0x12c7],
	[0x12cf, 0x12cf],
	[0x12d7, 0x12d7],
	[0x12ef, 0x12ef],
	[0x130f, 0x130f],
	[0x1311, 0x1311],
	[0x1316, 0x1317],
	[0x131f, 0x131f],
	[0x1347, 0x1347],
	[0x135b, 0x1360],
	[0x137d, 0x139f],
	[0x13f5, 0x1400],
	[0x1677, 0x167f],
	[0x169d, 0x169f],
	[0x16f1, 0x16ff],
	[0x170d, 0x170d],
	[0x1715, 0x171f],
	[0x1737, 0x173f],
	[0x1754, 0x175f],
	[0x176d, 0x176d],
	[0x1771, 0x1771],
	[0x1774, 0x177f],
	[0x17dd, 0x17df],
	[0x17ea, 0x17ff],
	[0x180f, 0x180f],
	[0x181a, 0x181f],
	[0x1878, 0x187f],
	[0x18aa, 0x1dff],
	[0x1e9c, 0x1e9f],
	[0x1efa, 0x1eff],
	[0x1f16, 0x1f17],
	[0x1f1e, 0x1f1f],
	[0x1f46, 0x1f47],
	[0x1f4e, 0x1f4f],
	[0x1f58, 0x1f58],
	[0x1f5a, 0x1f5a],
	[0x1f5c, 0x1f5c],
	[0x1f5e, 0x1f5e],
	[0x1f7e, 0x1f7f],
	[0x1fb5, 0x1fb5],
	[0x1fc5, 0x1fc5],
	[0x1fd4, 0x1fd5],
	[0x1fdc, 0x1fdc],
	[0x1ff0, 0x1ff1],
	[0x1ff5, 0x1ff5],
	[0x1fff, 0x1fff],
	[0x2053, 0x2056],
	[0x2058, 0x205e],
	[0x2064, 0x2069],
	[0x2072, 0x2073],
	[0x208f, 0x209f],
	[0x20b2, 0x20cf],
	[0x20eb, 0x20ff],
	[0x213b, 0x213c],
	[0x214c, 0x2152],
	[0x2184, 0x218f],
	[0x23cf, 0x23ff],
	[0x2427, 0x243f],
	[0x244b, 0x245f],
	[0x24ff, 0x24ff],
	[0x2614, 0x2615],
	[0x2618, 0x2618],
	[0x267e, 0x267f],
	[0x268a, 0x2700],
	[0x2705, 0x2705],
	[0x270a, 0x270b],
	[0x2728, 0x2728],
	[0x274c, 0x274c],
	[0x274e, 0x274e],
	[0x2753, 0x2755],
	[0x2757, 0x2757],
	[0x275f, 0x2760],
	[0x2795, 0x2797],
	[0x27b0, 0x27b0],
	[0x27bf, 0x27cf],
	[0x27ec, 0x27ef],
	[0x2b00, 0x2e7f],
	[0x2e9a, 0x2e9a],
	[0x2ef4, 0x2eff],
	[0x2fd6, 0x2fef],
	[0x2ffc, 0x2fff],
	[0x3040, 0x3040],
	[0x3097, 0x3098],
	[0x3100, 0x3104],
	[0x312d, 0x3130],
	[0x318f, 0x318f],
	[0x31b8, 0x31ef],
	[0x321d, 0x321f],
	[0x3244, 0x3250],
	[0x327c, 0x327e],
	[0x32cc, 0x32cf],
	[0x32ff, 0x32ff],
	[0x3377, 0x337a],
	[0x33de, 0x33df],
	[0x33ff, 0x33ff],
	[0x4db6, 0x4dff],
	[0x9fa6, 0x9fff],
	[0xa48d, 0xa48f],
	[0xa4c7, 0xabff],
	[0xd7a4, 0xd7ff],
	[0xfa2e, 0xfa2f],
	[0xfa6b, 0xfaff],
	[0xfb07, 0xfb12],
	[0xfb18, 0xfb1c],
	[0xfb37, 0xfb37],
	[0xfb3d, 0xfb3d],
	[0xfb3f, 0xfb3f],
	[0xfb42, 0xfb42],
	[0xfb45, 0xfb45],
	[0xfbb2, 0xfbd2],
	[0xfd40, 0xfd4f],
	[0xfd90, 0xfd91],
	[0xfdc8, 0xfdcf],
	[0xfdfd, 0xfdff],
	[0xfe10, 0xfe1f],
	[0xfe24, 0xfe2f],
	[0xfe47, 0xfe48],
	[0xfe53, 0xfe53],
	[0xfe67, 0xfe67],
	[0xfe6c, 0xfe6f],
	[0xfe75, 0xfe75],
	[0xfefd, 0xfefe],
	[0xff00, 0xff00],
	[0xffbf, 0xffc1],
	[0xffc8, 0xffc9],
	[0xffd0, 0xffd1],
	[0xffd8, 0xffd9],
	[0xffdd, 0xffdf],
	[0xffe7, 0xffe7],
	[0xffef, 0xfff8],
	[0x10000, 0x102ff],
	[0x1031f, 0x1031f],
	[0x10324, 0x1032f],
	[0x1034b, 0x103ff],
	[0x10426, 0x10427],
	[0x1044e, 0x1cfff],
	[0x1d0f6, 0x1d0ff],
	[0x1d127, 0x1d129],
	[0x1d1de, 0x1d3ff],
	[0x1d455, 0x1d455],
	[0x1d49d, 0x1d49d],
	[0x1d4a0, 0x1d4a1],
	[0x1d4a3, 0x1d4a4],
	[0x1d4a7, 0x1d4a8],
	[0x1d4ad, 0x1d4ad],
	[0x1d4ba, 0x1d4ba],
	[0x1d4bc, 0x1d4bc],
	[0x1d4c1, 0x1d4c1],
	[0x1d4c4, 0x1d4c4],
	[0x1d506, 0x1d506],
	[0x1d50b, 0x1d50c],
	[0x1d515, 0x1d515],
	[0x1d51d, 0x1d51d],
	[0x1d53a, 0x1d53a],
	[0x1d53f, 0x1d53f],
	[0x1d545, 0x1d545],
	[0x1d547, 0x1d549],
	[0x1d551, 0x1d551],
	[0x1d6a4, 0x1d6a7],
	[0x1d7ca, 0x1d7cd],
	[0x1d800, 0x1fffd],
	[0x2a6d7, 0x2f7ff],
	[0x2fa1e, 0x2fffd],
	[0x30000, 0x3fffd],
	[0x40000, 0x4fffd],
	[0x50000, 0x5fffd],
	[0x60000, 0x6fffd],
	[0x70000, 0x7fffd],
	[0x80000, 0x8fffd],
	[0x90000, 0x9fffd],
	[0xa0000, 0xafffd],
	[0xb0000, 0xbfffd],
	[0xc0000, 0xcfffd],
	[0xd0000, 0xdfffd],
	[0xe0000, 0xe0000],
	[0xe0002, 0xe001f],
	[0xe0080, 0xefffd],
];

/**
 * RFC 3454 Appendix B.2 case fold (complete), keyed by source code point.
 * Identity entries are omitted; an absent key folds to itself.
 */
export const B2_CASE_FOLD: ReadonlyMap<string, string> = new Map<string, string>([
	['\u0041', 'a'],
	['\u0042', 'b'],
	['\u0043', 'c'],
	['\u0044', 'd'],
	['\u0045', 'e'],
	['\u0046', 'f'],
	['\u0047', 'g'],
	['\u0048', 'h'],
	['\u0049', 'i'],
	['\u004a', 'j'],
	['\u004b', 'k'],
	['\u004c', 'l'],
	['\u004d', 'm'],
	['\u004e', 'n'],
	['\u004f', 'o'],
	['\u0050', 'p'],
	['\u0051', 'q'],
	['\u0052', 'r'],
	['\u0053', 's'],
	['\u0054', 't'],
	['\u0055', 'u'],
	['\u0056', 'v'],
	['\u0057', 'w'],
	['\u0058', 'x'],
	['\u0059', 'y'],
	['\u005a', 'z'],
	['\u00b5', '\u03bc'],
	['\u00c0', '\u00e0'],
	['\u00c1', '\u00e1'],
	['\u00c2', '\u00e2'],
	['\u00c3', '\u00e3'],
	['\u00c4', '\u00e4'],
	['\u00c5', '\u00e5'],
	['\u00c6', '\u00e6'],
	['\u00c7', '\u00e7'],
	['\u00c8', '\u00e8'],
	['\u00c9', '\u00e9'],
	['\u00ca', '\u00ea'],
	['\u00cb', '\u00eb'],
	['\u00cc', '\u00ec'],
	['\u00cd', '\u00ed'],
	['\u00ce', '\u00ee'],
	['\u00cf', '\u00ef'],
	['\u00d0', '\u00f0'],
	['\u00d1', '\u00f1'],
	['\u00d2', '\u00f2'],
	['\u00d3', '\u00f3'],
	['\u00d4', '\u00f4'],
	['\u00d5', '\u00f5'],
	['\u00d6', '\u00f6'],
	['\u00d8', '\u00f8'],
	['\u00d9', '\u00f9'],
	['\u00da', '\u00fa'],
	['\u00db', '\u00fb'],
	['\u00dc', '\u00fc'],
	['\u00dd', '\u00fd'],
	['\u00de', '\u00fe'],
	['\u00df', 'ss'],
	['\u0100', '\u0101'],
	['\u0102', '\u0103'],
	['\u0104', '\u0105'],
	['\u0106', '\u0107'],
	['\u0108', '\u0109'],
	['\u010a', '\u010b'],
	['\u010c', '\u010d'],
	['\u010e', '\u010f'],
	['\u0110', '\u0111'],
	['\u0112', '\u0113'],
	['\u0114', '\u0115'],
	['\u0116', '\u0117'],
	['\u0118', '\u0119'],
	['\u011a', '\u011b'],
	['\u011c', '\u011d'],
	['\u011e', '\u011f'],
	['\u0120', '\u0121'],
	['\u0122', '\u0123'],
	['\u0124', '\u0125'],
	['\u0126', '\u0127'],
	['\u0128', '\u0129'],
	['\u012a', '\u012b'],
	['\u012c', '\u012d'],
	['\u012e', '\u012f'],
	['\u0130', 'i\u0307'],
	['\u0132', '\u0133'],
	['\u0134', '\u0135'],
	['\u0136', '\u0137'],
	['\u0139', '\u013a'],
	['\u013b', '\u013c'],
	['\u013d', '\u013e'],
	['\u013f', '\u0140'],
	['\u0141', '\u0142'],
	['\u0143', '\u0144'],
	['\u0145', '\u0146'],
	['\u0147', '\u0148'],
	['\u0149', '\u02bcn'],
	['\u014a', '\u014b'],
	['\u014c', '\u014d'],
	['\u014e', '\u014f'],
	['\u0150', '\u0151'],
	['\u0152', '\u0153'],
	['\u0154', '\u0155'],
	['\u0156', '\u0157'],
	['\u0158', '\u0159'],
	['\u015a', '\u015b'],
	['\u015c', '\u015d'],
	['\u015e', '\u015f'],
	['\u0160', '\u0161'],
	['\u0162', '\u0163'],
	['\u0164', '\u0165'],
	['\u0166', '\u0167'],
	['\u0168', '\u0169'],
	['\u016a', '\u016b'],
	['\u016c', '\u016d'],
	['\u016e', '\u016f'],
	['\u0170', '\u0171'],
	['\u0172', '\u0173'],
	['\u0174', '\u0175'],
	['\u0176', '\u0177'],
	['\u0178', '\u00ff'],
	['\u0179', '\u017a'],
	['\u017b', '\u017c'],
	['\u017d', '\u017e'],
	['\u017f', 's'],
	['\u0181', '\u0253'],
	['\u0182', '\u0183'],
	['\u0184', '\u0185'],
	['\u0186', '\u0254'],
	['\u0187', '\u0188'],
	['\u0189', '\u0256'],
	['\u018a', '\u0257'],
	['\u018b', '\u018c'],
	['\u018e', '\u01dd'],
	['\u018f', '\u0259'],
	['\u0190', '\u025b'],
	['\u0191', '\u0192'],
	['\u0193', '\u0260'],
	['\u0194', '\u0263'],
	['\u0196', '\u0269'],
	['\u0197', '\u0268'],
	['\u0198', '\u0199'],
	['\u019c', '\u026f'],
	['\u019d', '\u0272'],
	['\u019f', '\u0275'],
	['\u01a0', '\u01a1'],
	['\u01a2', '\u01a3'],
	['\u01a4', '\u01a5'],
	['\u01a6', '\u0280'],
	['\u01a7', '\u01a8'],
	['\u01a9', '\u0283'],
	['\u01ac', '\u01ad'],
	['\u01ae', '\u0288'],
	['\u01af', '\u01b0'],
	['\u01b1', '\u028a'],
	['\u01b2', '\u028b'],
	['\u01b3', '\u01b4'],
	['\u01b5', '\u01b6'],
	['\u01b7', '\u0292'],
	['\u01b8', '\u01b9'],
	['\u01bc', '\u01bd'],
	['\u01c4', '\u01c6'],
	['\u01c5', '\u01c6'],
	['\u01c7', '\u01c9'],
	['\u01c8', '\u01c9'],
	['\u01ca', '\u01cc'],
	['\u01cb', '\u01cc'],
	['\u01cd', '\u01ce'],
	['\u01cf', '\u01d0'],
	['\u01d1', '\u01d2'],
	['\u01d3', '\u01d4'],
	['\u01d5', '\u01d6'],
	['\u01d7', '\u01d8'],
	['\u01d9', '\u01da'],
	['\u01db', '\u01dc'],
	['\u01de', '\u01df'],
	['\u01e0', '\u01e1'],
	['\u01e2', '\u01e3'],
	['\u01e4', '\u01e5'],
	['\u01e6', '\u01e7'],
	['\u01e8', '\u01e9'],
	['\u01ea', '\u01eb'],
	['\u01ec', '\u01ed'],
	['\u01ee', '\u01ef'],
	['\u01f0', 'j\u030c'],
	['\u01f1', '\u01f3'],
	['\u01f2', '\u01f3'],
	['\u01f4', '\u01f5'],
	['\u01f6', '\u0195'],
	['\u01f7', '\u01bf'],
	['\u01f8', '\u01f9'],
	['\u01fa', '\u01fb'],
	['\u01fc', '\u01fd'],
	['\u01fe', '\u01ff'],
	['\u0200', '\u0201'],
	['\u0202', '\u0203'],
	['\u0204', '\u0205'],
	['\u0206', '\u0207'],
	['\u0208', '\u0209'],
	['\u020a', '\u020b'],
	['\u020c', '\u020d'],
	['\u020e', '\u020f'],
	['\u0210', '\u0211'],
	['\u0212', '\u0213'],
	['\u0214', '\u0215'],
	['\u0216', '\u0217'],
	['\u0218', '\u0219'],
	['\u021a', '\u021b'],
	['\u021c', '\u021d'],
	['\u021e', '\u021f'],
	['\u0220', '\u019e'],
	['\u0222', '\u0223'],
	['\u0224', '\u0225'],
	['\u0226', '\u0227'],
	['\u0228', '\u0229'],
	['\u022a', '\u022b'],
	['\u022c', '\u022d'],
	['\u022e', '\u022f'],
	['\u0230', '\u0231'],
	['\u0232', '\u0233'],
	['\u0345', '\u03b9'],
	['\u037a', ' \u03b9'],
	['\u0386', '\u03ac'],
	['\u0388', '\u03ad'],
	['\u0389', '\u03ae'],
	['\u038a', '\u03af'],
	['\u038c', '\u03cc'],
	['\u038e', '\u03cd'],
	['\u038f', '\u03ce'],
	['\u0390', '\u03b9\u0308\u0301'],
	['\u0391', '\u03b1'],
	['\u0392', '\u03b2'],
	['\u0393', '\u03b3'],
	['\u0394', '\u03b4'],
	['\u0395', '\u03b5'],
	['\u0396', '\u03b6'],
	['\u0397', '\u03b7'],
	['\u0398', '\u03b8'],
	['\u0399', '\u03b9'],
	['\u039a', '\u03ba'],
	['\u039b', '\u03bb'],
	['\u039c', '\u03bc'],
	['\u039d', '\u03bd'],
	['\u039e', '\u03be'],
	['\u039f', '\u03bf'],
	['\u03a0', '\u03c0'],
	['\u03a1', '\u03c1'],
	['\u03a3', '\u03c3'],
	['\u03a4', '\u03c4'],
	['\u03a5', '\u03c5'],
	['\u03a6', '\u03c6'],
	['\u03a7', '\u03c7'],
	['\u03a8', '\u03c8'],
	['\u03a9', '\u03c9'],
	['\u03aa', '\u03ca'],
	['\u03ab', '\u03cb'],
	['\u03b0', '\u03c5\u0308\u0301'],
	['\u03c2', '\u03c3'],
	['\u03d0', '\u03b2'],
	['\u03d1', '\u03b8'],
	['\u03d2', '\u03c5'],
	['\u03d3', '\u03cd'],
	['\u03d4', '\u03cb'],
	['\u03d5', '\u03c6'],
	['\u03d6', '\u03c0'],
	['\u03d8', '\u03d9'],
	['\u03da', '\u03db'],
	['\u03dc', '\u03dd'],
	['\u03de', '\u03df'],
	['\u03e0', '\u03e1'],
	['\u03e2', '\u03e3'],
	['\u03e4', '\u03e5'],
	['\u03e6', '\u03e7'],
	['\u03e8', '\u03e9'],
	['\u03ea', '\u03eb'],
	['\u03ec', '\u03ed'],
	['\u03ee', '\u03ef'],
	['\u03f0', '\u03ba'],
	['\u03f1', '\u03c1'],
	['\u03f2', '\u03c3'],
	['\u03f4', '\u03b8'],
	['\u03f5', '\u03b5'],
	['\u0400', '\u0450'],
	['\u0401', '\u0451'],
	['\u0402', '\u0452'],
	['\u0403', '\u0453'],
	['\u0404', '\u0454'],
	['\u0405', '\u0455'],
	['\u0406', '\u0456'],
	['\u0407', '\u0457'],
	['\u0408', '\u0458'],
	['\u0409', '\u0459'],
	['\u040a', '\u045a'],
	['\u040b', '\u045b'],
	['\u040c', '\u045c'],
	['\u040d', '\u045d'],
	['\u040e', '\u045e'],
	['\u040f', '\u045f'],
	['\u0410', '\u0430'],
	['\u0411', '\u0431'],
	['\u0412', '\u0432'],
	['\u0413', '\u0433'],
	['\u0414', '\u0434'],
	['\u0415', '\u0435'],
	['\u0416', '\u0436'],
	['\u0417', '\u0437'],
	['\u0418', '\u0438'],
	['\u0419', '\u0439'],
	['\u041a', '\u043a'],
	['\u041b', '\u043b'],
	['\u041c', '\u043c'],
	['\u041d', '\u043d'],
	['\u041e', '\u043e'],
	['\u041f', '\u043f'],
	['\u0420', '\u0440'],
	['\u0421', '\u0441'],
	['\u0422', '\u0442'],
	['\u0423', '\u0443'],
	['\u0424', '\u0444'],
	['\u0425', '\u0445'],
	['\u0426', '\u0446'],
	['\u0427', '\u0447'],
	['\u0428', '\u0448'],
	['\u0429', '\u0449'],
	['\u042a', '\u044a'],
	['\u042b', '\u044b'],
	['\u042c', '\u044c'],
	['\u042d', '\u044d'],
	['\u042e', '\u044e'],
	['\u042f', '\u044f'],
	['\u0460', '\u0461'],
	['\u0462', '\u0463'],
	['\u0464', '\u0465'],
	['\u0466', '\u0467'],
	['\u0468', '\u0469'],
	['\u046a', '\u046b'],
	['\u046c', '\u046d'],
	['\u046e', '\u046f'],
	['\u0470', '\u0471'],
	['\u0472', '\u0473'],
	['\u0474', '\u0475'],
	['\u0476', '\u0477'],
	['\u0478', '\u0479'],
	['\u047a', '\u047b'],
	['\u047c', '\u047d'],
	['\u047e', '\u047f'],
	['\u0480', '\u0481'],
	['\u048a', '\u048b'],
	['\u048c', '\u048d'],
	['\u048e', '\u048f'],
	['\u0490', '\u0491'],
	['\u0492', '\u0493'],
	['\u0494', '\u0495'],
	['\u0496', '\u0497'],
	['\u0498', '\u0499'],
	['\u049a', '\u049b'],
	['\u049c', '\u049d'],
	['\u049e', '\u049f'],
	['\u04a0', '\u04a1'],
	['\u04a2', '\u04a3'],
	['\u04a4', '\u04a5'],
	['\u04a6', '\u04a7'],
	['\u04a8', '\u04a9'],
	['\u04aa', '\u04ab'],
	['\u04ac', '\u04ad'],
	['\u04ae', '\u04af'],
	['\u04b0', '\u04b1'],
	['\u04b2', '\u04b3'],
	['\u04b4', '\u04b5'],
	['\u04b6', '\u04b7'],
	['\u04b8', '\u04b9'],
	['\u04ba', '\u04bb'],
	['\u04bc', '\u04bd'],
	['\u04be', '\u04bf'],
	['\u04c1', '\u04c2'],
	['\u04c3', '\u04c4'],
	['\u04c5', '\u04c6'],
	['\u04c7', '\u04c8'],
	['\u04c9', '\u04ca'],
	['\u04cb', '\u04cc'],
	['\u04cd', '\u04ce'],
	['\u04d0', '\u04d1'],
	['\u04d2', '\u04d3'],
	['\u04d4', '\u04d5'],
	['\u04d6', '\u04d7'],
	['\u04d8', '\u04d9'],
	['\u04da', '\u04db'],
	['\u04dc', '\u04dd'],
	['\u04de', '\u04df'],
	['\u04e0', '\u04e1'],
	['\u04e2', '\u04e3'],
	['\u04e4', '\u04e5'],
	['\u04e6', '\u04e7'],
	['\u04e8', '\u04e9'],
	['\u04ea', '\u04eb'],
	['\u04ec', '\u04ed'],
	['\u04ee', '\u04ef'],
	['\u04f0', '\u04f1'],
	['\u04f2', '\u04f3'],
	['\u04f4', '\u04f5'],
	['\u04f8', '\u04f9'],
	['\u0500', '\u0501'],
	['\u0502', '\u0503'],
	['\u0504', '\u0505'],
	['\u0506', '\u0507'],
	['\u0508', '\u0509'],
	['\u050a', '\u050b'],
	['\u050c', '\u050d'],
	['\u050e', '\u050f'],
	['\u0531', '\u0561'],
	['\u0532', '\u0562'],
	['\u0533', '\u0563'],
	['\u0534', '\u0564'],
	['\u0535', '\u0565'],
	['\u0536', '\u0566'],
	['\u0537', '\u0567'],
	['\u0538', '\u0568'],
	['\u0539', '\u0569'],
	['\u053a', '\u056a'],
	['\u053b', '\u056b'],
	['\u053c', '\u056c'],
	['\u053d', '\u056d'],
	['\u053e', '\u056e'],
	['\u053f', '\u056f'],
	['\u0540', '\u0570'],
	['\u0541', '\u0571'],
	['\u0542', '\u0572'],
	['\u0543', '\u0573'],
	['\u0544', '\u0574'],
	['\u0545', '\u0575'],
	['\u0546', '\u0576'],
	['\u0547', '\u0577'],
	['\u0548', '\u0578'],
	['\u0549', '\u0579'],
	['\u054a', '\u057a'],
	['\u054b', '\u057b'],
	['\u054c', '\u057c'],
	['\u054d', '\u057d'],
	['\u054e', '\u057e'],
	['\u054f', '\u057f'],
	['\u0550', '\u0580'],
	['\u0551', '\u0581'],
	['\u0552', '\u0582'],
	['\u0553', '\u0583'],
	['\u0554', '\u0584'],
	['\u0555', '\u0585'],
	['\u0556', '\u0586'],
	['\u0587', '\u0565\u0582'],
	['\u1e00', '\u1e01'],
	['\u1e02', '\u1e03'],
	['\u1e04', '\u1e05'],
	['\u1e06', '\u1e07'],
	['\u1e08', '\u1e09'],
	['\u1e0a', '\u1e0b'],
	['\u1e0c', '\u1e0d'],
	['\u1e0e', '\u1e0f'],
	['\u1e10', '\u1e11'],
	['\u1e12', '\u1e13'],
	['\u1e14', '\u1e15'],
	['\u1e16', '\u1e17'],
	['\u1e18', '\u1e19'],
	['\u1e1a', '\u1e1b'],
	['\u1e1c', '\u1e1d'],
	['\u1e1e', '\u1e1f'],
	['\u1e20', '\u1e21'],
	['\u1e22', '\u1e23'],
	['\u1e24', '\u1e25'],
	['\u1e26', '\u1e27'],
	['\u1e28', '\u1e29'],
	['\u1e2a', '\u1e2b'],
	['\u1e2c', '\u1e2d'],
	['\u1e2e', '\u1e2f'],
	['\u1e30', '\u1e31'],
	['\u1e32', '\u1e33'],
	['\u1e34', '\u1e35'],
	['\u1e36', '\u1e37'],
	['\u1e38', '\u1e39'],
	['\u1e3a', '\u1e3b'],
	['\u1e3c', '\u1e3d'],
	['\u1e3e', '\u1e3f'],
	['\u1e40', '\u1e41'],
	['\u1e42', '\u1e43'],
	['\u1e44', '\u1e45'],
	['\u1e46', '\u1e47'],
	['\u1e48', '\u1e49'],
	['\u1e4a', '\u1e4b'],
	['\u1e4c', '\u1e4d'],
	['\u1e4e', '\u1e4f'],
	['\u1e50', '\u1e51'],
	['\u1e52', '\u1e53'],
	['\u1e54', '\u1e55'],
	['\u1e56', '\u1e57'],
	['\u1e58', '\u1e59'],
	['\u1e5a', '\u1e5b'],
	['\u1e5c', '\u1e5d'],
	['\u1e5e', '\u1e5f'],
	['\u1e60', '\u1e61'],
	['\u1e62', '\u1e63'],
	['\u1e64', '\u1e65'],
	['\u1e66', '\u1e67'],
	['\u1e68', '\u1e69'],
	['\u1e6a', '\u1e6b'],
	['\u1e6c', '\u1e6d'],
	['\u1e6e', '\u1e6f'],
	['\u1e70', '\u1e71'],
	['\u1e72', '\u1e73'],
	['\u1e74', '\u1e75'],
	['\u1e76', '\u1e77'],
	['\u1e78', '\u1e79'],
	['\u1e7a', '\u1e7b'],
	['\u1e7c', '\u1e7d'],
	['\u1e7e', '\u1e7f'],
	['\u1e80', '\u1e81'],
	['\u1e82', '\u1e83'],
	['\u1e84', '\u1e85'],
	['\u1e86', '\u1e87'],
	['\u1e88', '\u1e89'],
	['\u1e8a', '\u1e8b'],
	['\u1e8c', '\u1e8d'],
	['\u1e8e', '\u1e8f'],
	['\u1e90', '\u1e91'],
	['\u1e92', '\u1e93'],
	['\u1e94', '\u1e95'],
	['\u1e96', 'h\u0331'],
	['\u1e97', 't\u0308'],
	['\u1e98', 'w\u030a'],
	['\u1e99', 'y\u030a'],
	['\u1e9a', 'a\u02be'],
	['\u1e9b', '\u1e61'],
	['\u1ea0', '\u1ea1'],
	['\u1ea2', '\u1ea3'],
	['\u1ea4', '\u1ea5'],
	['\u1ea6', '\u1ea7'],
	['\u1ea8', '\u1ea9'],
	['\u1eaa', '\u1eab'],
	['\u1eac', '\u1ead'],
	['\u1eae', '\u1eaf'],
	['\u1eb0', '\u1eb1'],
	['\u1eb2', '\u1eb3'],
	['\u1eb4', '\u1eb5'],
	['\u1eb6', '\u1eb7'],
	['\u1eb8', '\u1eb9'],
	['\u1eba', '\u1ebb'],
	['\u1ebc', '\u1ebd'],
	['\u1ebe', '\u1ebf'],
	['\u1ec0', '\u1ec1'],
	['\u1ec2', '\u1ec3'],
	['\u1ec4', '\u1ec5'],
	['\u1ec6', '\u1ec7'],
	['\u1ec8', '\u1ec9'],
	['\u1eca', '\u1ecb'],
	['\u1ecc', '\u1ecd'],
	['\u1ece', '\u1ecf'],
	['\u1ed0', '\u1ed1'],
	['\u1ed2', '\u1ed3'],
	['\u1ed4', '\u1ed5'],
	['\u1ed6', '\u1ed7'],
	['\u1ed8', '\u1ed9'],
	['\u1eda', '\u1edb'],
	['\u1edc', '\u1edd'],
	['\u1ede', '\u1edf'],
	['\u1ee0', '\u1ee1'],
	['\u1ee2', '\u1ee3'],
	['\u1ee4', '\u1ee5'],
	['\u1ee6', '\u1ee7'],
	['\u1ee8', '\u1ee9'],
	['\u1eea', '\u1eeb'],
	['\u1eec', '\u1eed'],
	['\u1eee', '\u1eef'],
	['\u1ef0', '\u1ef1'],
	['\u1ef2', '\u1ef3'],
	['\u1ef4', '\u1ef5'],
	['\u1ef6', '\u1ef7'],
	['\u1ef8', '\u1ef9'],
	['\u1f08', '\u1f00'],
	['\u1f09', '\u1f01'],
	['\u1f0a', '\u1f02'],
	['\u1f0b', '\u1f03'],
	['\u1f0c', '\u1f04'],
	['\u1f0d', '\u1f05'],
	['\u1f0e', '\u1f06'],
	['\u1f0f', '\u1f07'],
	['\u1f18', '\u1f10'],
	['\u1f19', '\u1f11'],
	['\u1f1a', '\u1f12'],
	['\u1f1b', '\u1f13'],
	['\u1f1c', '\u1f14'],
	['\u1f1d', '\u1f15'],
	['\u1f28', '\u1f20'],
	['\u1f29', '\u1f21'],
	['\u1f2a', '\u1f22'],
	['\u1f2b', '\u1f23'],
	['\u1f2c', '\u1f24'],
	['\u1f2d', '\u1f25'],
	['\u1f2e', '\u1f26'],
	['\u1f2f', '\u1f27'],
	['\u1f38', '\u1f30'],
	['\u1f39', '\u1f31'],
	['\u1f3a', '\u1f32'],
	['\u1f3b', '\u1f33'],
	['\u1f3c', '\u1f34'],
	['\u1f3d', '\u1f35'],
	['\u1f3e', '\u1f36'],
	['\u1f3f', '\u1f37'],
	['\u1f48', '\u1f40'],
	['\u1f49', '\u1f41'],
	['\u1f4a', '\u1f42'],
	['\u1f4b', '\u1f43'],
	['\u1f4c', '\u1f44'],
	['\u1f4d', '\u1f45'],
	['\u1f50', '\u03c5\u0313'],
	['\u1f52', '\u03c5\u0313\u0300'],
	['\u1f54', '\u03c5\u0313\u0301'],
	['\u1f56', '\u03c5\u0313\u0342'],
	['\u1f59', '\u1f51'],
	['\u1f5b', '\u1f53'],
	['\u1f5d', '\u1f55'],
	['\u1f5f', '\u1f57'],
	['\u1f68', '\u1f60'],
	['\u1f69', '\u1f61'],
	['\u1f6a', '\u1f62'],
	['\u1f6b', '\u1f63'],
	['\u1f6c', '\u1f64'],
	['\u1f6d', '\u1f65'],
	['\u1f6e', '\u1f66'],
	['\u1f6f', '\u1f67'],
	['\u1f80', '\u1f00\u03b9'],
	['\u1f81', '\u1f01\u03b9'],
	['\u1f82', '\u1f02\u03b9'],
	['\u1f83', '\u1f03\u03b9'],
	['\u1f84', '\u1f04\u03b9'],
	['\u1f85', '\u1f05\u03b9'],
	['\u1f86', '\u1f06\u03b9'],
	['\u1f87', '\u1f07\u03b9'],
	['\u1f88', '\u1f00\u03b9'],
	['\u1f89', '\u1f01\u03b9'],
	['\u1f8a', '\u1f02\u03b9'],
	['\u1f8b', '\u1f03\u03b9'],
	['\u1f8c', '\u1f04\u03b9'],
	['\u1f8d', '\u1f05\u03b9'],
	['\u1f8e', '\u1f06\u03b9'],
	['\u1f8f', '\u1f07\u03b9'],
	['\u1f90', '\u1f20\u03b9'],
	['\u1f91', '\u1f21\u03b9'],
	['\u1f92', '\u1f22\u03b9'],
	['\u1f93', '\u1f23\u03b9'],
	['\u1f94', '\u1f24\u03b9'],
	['\u1f95', '\u1f25\u03b9'],
	['\u1f96', '\u1f26\u03b9'],
	['\u1f97', '\u1f27\u03b9'],
	['\u1f98', '\u1f20\u03b9'],
	['\u1f99', '\u1f21\u03b9'],
	['\u1f9a', '\u1f22\u03b9'],
	['\u1f9b', '\u1f23\u03b9'],
	['\u1f9c', '\u1f24\u03b9'],
	['\u1f9d', '\u1f25\u03b9'],
	['\u1f9e', '\u1f26\u03b9'],
	['\u1f9f', '\u1f27\u03b9'],
	['\u1fa0', '\u1f60\u03b9'],
	['\u1fa1', '\u1f61\u03b9'],
	['\u1fa2', '\u1f62\u03b9'],
	['\u1fa3', '\u1f63\u03b9'],
	['\u1fa4', '\u1f64\u03b9'],
	['\u1fa5', '\u1f65\u03b9'],
	['\u1fa6', '\u1f66\u03b9'],
	['\u1fa7', '\u1f67\u03b9'],
	['\u1fa8', '\u1f60\u03b9'],
	['\u1fa9', '\u1f61\u03b9'],
	['\u1faa', '\u1f62\u03b9'],
	['\u1fab', '\u1f63\u03b9'],
	['\u1fac', '\u1f64\u03b9'],
	['\u1fad', '\u1f65\u03b9'],
	['\u1fae', '\u1f66\u03b9'],
	['\u1faf', '\u1f67\u03b9'],
	['\u1fb2', '\u1f70\u03b9'],
	['\u1fb3', '\u03b1\u03b9'],
	['\u1fb4', '\u03ac\u03b9'],
	['\u1fb6', '\u03b1\u0342'],
	['\u1fb7', '\u03b1\u0342\u03b9'],
	['\u1fb8', '\u1fb0'],
	['\u1fb9', '\u1fb1'],
	['\u1fba', '\u1f70'],
	['\u1fbb', '\u1f71'],
	['\u1fbc', '\u03b1\u03b9'],
	['\u1fbe', '\u03b9'],
	['\u1fc2', '\u1f74\u03b9'],
	['\u1fc3', '\u03b7\u03b9'],
	['\u1fc4', '\u03ae\u03b9'],
	['\u1fc6', '\u03b7\u0342'],
	['\u1fc7', '\u03b7\u0342\u03b9'],
	['\u1fc8', '\u1f72'],
	['\u1fc9', '\u1f73'],
	['\u1fca', '\u1f74'],
	['\u1fcb', '\u1f75'],
	['\u1fcc', '\u03b7\u03b9'],
	['\u1fd2', '\u03b9\u0308\u0300'],
	['\u1fd3', '\u03b9\u0308\u0301'],
	['\u1fd6', '\u03b9\u0342'],
	['\u1fd7', '\u03b9\u0308\u0342'],
	['\u1fd8', '\u1fd0'],
	['\u1fd9', '\u1fd1'],
	['\u1fda', '\u1f76'],
	['\u1fdb', '\u1f77'],
	['\u1fe2', '\u03c5\u0308\u0300'],
	['\u1fe3', '\u03c5\u0308\u0301'],
	['\u1fe4', '\u03c1\u0313'],
	['\u1fe6', '\u03c5\u0342'],
	['\u1fe7', '\u03c5\u0308\u0342'],
	['\u1fe8', '\u1fe0'],
	['\u1fe9', '\u1fe1'],
	['\u1fea', '\u1f7a'],
	['\u1feb', '\u1f7b'],
	['\u1fec', '\u1fe5'],
	['\u1ff2', '\u1f7c\u03b9'],
	['\u1ff3', '\u03c9\u03b9'],
	['\u1ff4', '\u03ce\u03b9'],
	['\u1ff6', '\u03c9\u0342'],
	['\u1ff7', '\u03c9\u0342\u03b9'],
	['\u1ff8', '\u1f78'],
	['\u1ff9', '\u1f79'],
	['\u1ffa', '\u1f7c'],
	['\u1ffb', '\u1f7d'],
	['\u1ffc', '\u03c9\u03b9'],
	['\u20a8', 'rs'],
	['\u2102', 'c'],
	['\u2103', '\u00b0c'],
	['\u2107', '\u025b'],
	['\u2109', '\u00b0f'],
	['\u210b', 'h'],
	['\u210c', 'h'],
	['\u210d', 'h'],
	['\u2110', 'i'],
	['\u2111', 'i'],
	['\u2112', 'l'],
	['\u2115', 'n'],
	['\u2116', 'no'],
	['\u2119', 'p'],
	['\u211a', 'q'],
	['\u211b', 'r'],
	['\u211c', 'r'],
	['\u211d', 'r'],
	['\u2120', 'sm'],
	['\u2121', 'tel'],
	['\u2122', 'tm'],
	['\u2124', 'z'],
	['\u2126', '\u03c9'],
	['\u2128', 'z'],
	['\u212a', 'k'],
	['\u212b', '\u00e5'],
	['\u212c', 'b'],
	['\u212d', 'c'],
	['\u2130', 'e'],
	['\u2131', 'f'],
	['\u2133', 'm'],
	['\u213e', '\u03b3'],
	['\u213f', '\u03c0'],
	['\u2145', 'd'],
	['\u2160', '\u2170'],
	['\u2161', '\u2171'],
	['\u2162', '\u2172'],
	['\u2163', '\u2173'],
	['\u2164', '\u2174'],
	['\u2165', '\u2175'],
	['\u2166', '\u2176'],
	['\u2167', '\u2177'],
	['\u2168', '\u2178'],
	['\u2169', '\u2179'],
	['\u216a', '\u217a'],
	['\u216b', '\u217b'],
	['\u216c', '\u217c'],
	['\u216d', '\u217d'],
	['\u216e', '\u217e'],
	['\u216f', '\u217f'],
	['\u24b6', '\u24d0'],
	['\u24b7', '\u24d1'],
	['\u24b8', '\u24d2'],
	['\u24b9', '\u24d3'],
	['\u24ba', '\u24d4'],
	['\u24bb', '\u24d5'],
	['\u24bc', '\u24d6'],
	['\u24bd', '\u24d7'],
	['\u24be', '\u24d8'],
	['\u24bf', '\u24d9'],
	['\u24c0', '\u24da'],
	['\u24c1', '\u24db'],
	['\u24c2', '\u24dc'],
	['\u24c3', '\u24dd'],
	['\u24c4', '\u24de'],
	['\u24c5', '\u24df'],
	['\u24c6', '\u24e0'],
	['\u24c7', '\u24e1'],
	['\u24c8', '\u24e2'],
	['\u24c9', '\u24e3'],
	['\u24ca', '\u24e4'],
	['\u24cb', '\u24e5'],
	['\u24cc', '\u24e6'],
	['\u24cd', '\u24e7'],
	['\u24ce', '\u24e8'],
	['\u24cf', '\u24e9'],
	['\u3371', 'hpa'],
	['\u3373', 'au'],
	['\u3375', 'ov'],
	['\u3380', 'pa'],
	['\u3381', 'na'],
	['\u3382', '\u03bca'],
	['\u3383', 'ma'],
	['\u3384', 'ka'],
	['\u3385', 'kb'],
	['\u3386', 'mb'],
	['\u3387', 'gb'],
	['\u338a', 'pf'],
	['\u338b', 'nf'],
	['\u338c', '\u03bcf'],
	['\u3390', 'hz'],
	['\u3391', 'khz'],
	['\u3392', 'mhz'],
	['\u3393', 'ghz'],
	['\u3394', 'thz'],
	['\u33a9', 'pa'],
	['\u33aa', 'kpa'],
	['\u33ab', 'mpa'],
	['\u33ac', 'gpa'],
	['\u33b4', 'pv'],
	['\u33b5', 'nv'],
	['\u33b6', '\u03bcv'],
	['\u33b7', 'mv'],
	['\u33b8', 'kv'],
	['\u33b9', 'mv'],
	['\u33ba', 'pw'],
	['\u33bb', 'nw'],
	['\u33bc', '\u03bcw'],
	['\u33bd', 'mw'],
	['\u33be', 'kw'],
	['\u33bf', 'mw'],
	['\u33c0', 'k\u03c9'],
	['\u33c1', 'm\u03c9'],
	['\u33c3', 'bq'],
	['\u33c6', 'c\u2215kg'],
	['\u33c7', 'co.'],
	['\u33c8', 'db'],
	['\u33c9', 'gy'],
	['\u33cb', 'hp'],
	['\u33cd', 'kk'],
	['\u33ce', 'km'],
	['\u33d7', 'ph'],
	['\u33d9', 'ppm'],
	['\u33da', 'pr'],
	['\u33dc', 'sv'],
	['\u33dd', 'wb'],
	['\ufb00', 'ff'],
	['\ufb01', 'fi'],
	['\ufb02', 'fl'],
	['\ufb03', 'ffi'],
	['\ufb04', 'ffl'],
	['\ufb05', 'st'],
	['\ufb06', 'st'],
	['\ufb13', '\u0574\u0576'],
	['\ufb14', '\u0574\u0565'],
	['\ufb15', '\u0574\u056b'],
	['\ufb16', '\u057e\u0576'],
	['\ufb17', '\u0574\u056d'],
	['\uff21', '\uff41'],
	['\uff22', '\uff42'],
	['\uff23', '\uff43'],
	['\uff24', '\uff44'],
	['\uff25', '\uff45'],
	['\uff26', '\uff46'],
	['\uff27', '\uff47'],
	['\uff28', '\uff48'],
	['\uff29', '\uff49'],
	['\uff2a', '\uff4a'],
	['\uff2b', '\uff4b'],
	['\uff2c', '\uff4c'],
	['\uff2d', '\uff4d'],
	['\uff2e', '\uff4e'],
	['\uff2f', '\uff4f'],
	['\uff30', '\uff50'],
	['\uff31', '\uff51'],
	['\uff32', '\uff52'],
	['\uff33', '\uff53'],
	['\uff34', '\uff54'],
	['\uff35', '\uff55'],
	['\uff36', '\uff56'],
	['\uff37', '\uff57'],
	['\uff38', '\uff58'],
	['\uff39', '\uff59'],
	['\uff3a', '\uff5a'],
	['\u{10400}', '\u{10428}'],
	['\u{10401}', '\u{10429}'],
	['\u{10402}', '\u{1042a}'],
	['\u{10403}', '\u{1042b}'],
	['\u{10404}', '\u{1042c}'],
	['\u{10405}', '\u{1042d}'],
	['\u{10406}', '\u{1042e}'],
	['\u{10407}', '\u{1042f}'],
	['\u{10408}', '\u{10430}'],
	['\u{10409}', '\u{10431}'],
	['\u{1040a}', '\u{10432}'],
	['\u{1040b}', '\u{10433}'],
	['\u{1040c}', '\u{10434}'],
	['\u{1040d}', '\u{10435}'],
	['\u{1040e}', '\u{10436}'],
	['\u{1040f}', '\u{10437}'],
	['\u{10410}', '\u{10438}'],
	['\u{10411}', '\u{10439}'],
	['\u{10412}', '\u{1043a}'],
	['\u{10413}', '\u{1043b}'],
	['\u{10414}', '\u{1043c}'],
	['\u{10415}', '\u{1043d}'],
	['\u{10416}', '\u{1043e}'],
	['\u{10417}', '\u{1043f}'],
	['\u{10418}', '\u{10440}'],
	['\u{10419}', '\u{10441}'],
	['\u{1041a}', '\u{10442}'],
	['\u{1041b}', '\u{10443}'],
	['\u{1041c}', '\u{10444}'],
	['\u{1041d}', '\u{10445}'],
	['\u{1041e}', '\u{10446}'],
	['\u{1041f}', '\u{10447}'],
	['\u{10420}', '\u{10448}'],
	['\u{10421}', '\u{10449}'],
	['\u{10422}', '\u{1044a}'],
	['\u{10423}', '\u{1044b}'],
	['\u{10424}', '\u{1044c}'],
	['\u{10425}', '\u{1044d}'],
	['\u{1d400}', 'a'],
	['\u{1d401}', 'b'],
	['\u{1d402}', 'c'],
	['\u{1d403}', 'd'],
	['\u{1d404}', 'e'],
	['\u{1d405}', 'f'],
	['\u{1d406}', 'g'],
	['\u{1d407}', 'h'],
	['\u{1d408}', 'i'],
	['\u{1d409}', 'j'],
	['\u{1d40a}', 'k'],
	['\u{1d40b}', 'l'],
	['\u{1d40c}', 'm'],
	['\u{1d40d}', 'n'],
	['\u{1d40e}', 'o'],
	['\u{1d40f}', 'p'],
	['\u{1d410}', 'q'],
	['\u{1d411}', 'r'],
	['\u{1d412}', 's'],
	['\u{1d413}', 't'],
	['\u{1d414}', 'u'],
	['\u{1d415}', 'v'],
	['\u{1d416}', 'w'],
	['\u{1d417}', 'x'],
	['\u{1d418}', 'y'],
	['\u{1d419}', 'z'],
	['\u{1d434}', 'a'],
	['\u{1d435}', 'b'],
	['\u{1d436}', 'c'],
	['\u{1d437}', 'd'],
	['\u{1d438}', 'e'],
	['\u{1d439}', 'f'],
	['\u{1d43a}', 'g'],
	['\u{1d43b}', 'h'],
	['\u{1d43c}', 'i'],
	['\u{1d43d}', 'j'],
	['\u{1d43e}', 'k'],
	['\u{1d43f}', 'l'],
	['\u{1d440}', 'm'],
	['\u{1d441}', 'n'],
	['\u{1d442}', 'o'],
	['\u{1d443}', 'p'],
	['\u{1d444}', 'q'],
	['\u{1d445}', 'r'],
	['\u{1d446}', 's'],
	['\u{1d447}', 't'],
	['\u{1d448}', 'u'],
	['\u{1d449}', 'v'],
	['\u{1d44a}', 'w'],
	['\u{1d44b}', 'x'],
	['\u{1d44c}', 'y'],
	['\u{1d44d}', 'z'],
	['\u{1d468}', 'a'],
	['\u{1d469}', 'b'],
	['\u{1d46a}', 'c'],
	['\u{1d46b}', 'd'],
	['\u{1d46c}', 'e'],
	['\u{1d46d}', 'f'],
	['\u{1d46e}', 'g'],
	['\u{1d46f}', 'h'],
	['\u{1d470}', 'i'],
	['\u{1d471}', 'j'],
	['\u{1d472}', 'k'],
	['\u{1d473}', 'l'],
	['\u{1d474}', 'm'],
	['\u{1d475}', 'n'],
	['\u{1d476}', 'o'],
	['\u{1d477}', 'p'],
	['\u{1d478}', 'q'],
	['\u{1d479}', 'r'],
	['\u{1d47a}', 's'],
	['\u{1d47b}', 't'],
	['\u{1d47c}', 'u'],
	['\u{1d47d}', 'v'],
	['\u{1d47e}', 'w'],
	['\u{1d47f}', 'x'],
	['\u{1d480}', 'y'],
	['\u{1d481}', 'z'],
	['\u{1d49c}', 'a'],
	['\u{1d49e}', 'c'],
	['\u{1d49f}', 'd'],
	['\u{1d4a2}', 'g'],
	['\u{1d4a5}', 'j'],
	['\u{1d4a6}', 'k'],
	['\u{1d4a9}', 'n'],
	['\u{1d4aa}', 'o'],
	['\u{1d4ab}', 'p'],
	['\u{1d4ac}', 'q'],
	['\u{1d4ae}', 's'],
	['\u{1d4af}', 't'],
	['\u{1d4b0}', 'u'],
	['\u{1d4b1}', 'v'],
	['\u{1d4b2}', 'w'],
	['\u{1d4b3}', 'x'],
	['\u{1d4b4}', 'y'],
	['\u{1d4b5}', 'z'],
	['\u{1d4d0}', 'a'],
	['\u{1d4d1}', 'b'],
	['\u{1d4d2}', 'c'],
	['\u{1d4d3}', 'd'],
	['\u{1d4d4}', 'e'],
	['\u{1d4d5}', 'f'],
	['\u{1d4d6}', 'g'],
	['\u{1d4d7}', 'h'],
	['\u{1d4d8}', 'i'],
	['\u{1d4d9}', 'j'],
	['\u{1d4da}', 'k'],
	['\u{1d4db}', 'l'],
	['\u{1d4dc}', 'm'],
	['\u{1d4dd}', 'n'],
	['\u{1d4de}', 'o'],
	['\u{1d4df}', 'p'],
	['\u{1d4e0}', 'q'],
	['\u{1d4e1}', 'r'],
	['\u{1d4e2}', 's'],
	['\u{1d4e3}', 't'],
	['\u{1d4e4}', 'u'],
	['\u{1d4e5}', 'v'],
	['\u{1d4e6}', 'w'],
	['\u{1d4e7}', 'x'],
	['\u{1d4e8}', 'y'],
	['\u{1d4e9}', 'z'],
	['\u{1d504}', 'a'],
	['\u{1d505}', 'b'],
	['\u{1d507}', 'd'],
	['\u{1d508}', 'e'],
	['\u{1d509}', 'f'],
	['\u{1d50a}', 'g'],
	['\u{1d50d}', 'j'],
	['\u{1d50e}', 'k'],
	['\u{1d50f}', 'l'],
	['\u{1d510}', 'm'],
	['\u{1d511}', 'n'],
	['\u{1d512}', 'o'],
	['\u{1d513}', 'p'],
	['\u{1d514}', 'q'],
	['\u{1d516}', 's'],
	['\u{1d517}', 't'],
	['\u{1d518}', 'u'],
	['\u{1d519}', 'v'],
	['\u{1d51a}', 'w'],
	['\u{1d51b}', 'x'],
	['\u{1d51c}', 'y'],
	['\u{1d538}', 'a'],
	['\u{1d539}', 'b'],
	['\u{1d53b}', 'd'],
	['\u{1d53c}', 'e'],
	['\u{1d53d}', 'f'],
	['\u{1d53e}', 'g'],
	['\u{1d540}', 'i'],
	['\u{1d541}', 'j'],
	['\u{1d542}', 'k'],
	['\u{1d543}', 'l'],
	['\u{1d544}', 'm'],
	['\u{1d546}', 'o'],
	['\u{1d54a}', 's'],
	['\u{1d54b}', 't'],
	['\u{1d54c}', 'u'],
	['\u{1d54d}', 'v'],
	['\u{1d54e}', 'w'],
	['\u{1d54f}', 'x'],
	['\u{1d550}', 'y'],
	['\u{1d56c}', 'a'],
	['\u{1d56d}', 'b'],
	['\u{1d56e}', 'c'],
	['\u{1d56f}', 'd'],
	['\u{1d570}', 'e'],
	['\u{1d571}', 'f'],
	['\u{1d572}', 'g'],
	['\u{1d573}', 'h'],
	['\u{1d574}', 'i'],
	['\u{1d575}', 'j'],
	['\u{1d576}', 'k'],
	['\u{1d577}', 'l'],
	['\u{1d578}', 'm'],
	['\u{1d579}', 'n'],
	['\u{1d57a}', 'o'],
	['\u{1d57b}', 'p'],
	['\u{1d57c}', 'q'],
	['\u{1d57d}', 'r'],
	['\u{1d57e}', 's'],
	['\u{1d57f}', 't'],
	['\u{1d580}', 'u'],
	['\u{1d581}', 'v'],
	['\u{1d582}', 'w'],
	['\u{1d583}', 'x'],
	['\u{1d584}', 'y'],
	['\u{1d585}', 'z'],
	['\u{1d5a0}', 'a'],
	['\u{1d5a1}', 'b'],
	['\u{1d5a2}', 'c'],
	['\u{1d5a3}', 'd'],
	['\u{1d5a4}', 'e'],
	['\u{1d5a5}', 'f'],
	['\u{1d5a6}', 'g'],
	['\u{1d5a7}', 'h'],
	['\u{1d5a8}', 'i'],
	['\u{1d5a9}', 'j'],
	['\u{1d5aa}', 'k'],
	['\u{1d5ab}', 'l'],
	['\u{1d5ac}', 'm'],
	['\u{1d5ad}', 'n'],
	['\u{1d5ae}', 'o'],
	['\u{1d5af}', 'p'],
	['\u{1d5b0}', 'q'],
	['\u{1d5b1}', 'r'],
	['\u{1d5b2}', 's'],
	['\u{1d5b3}', 't'],
	['\u{1d5b4}', 'u'],
	['\u{1d5b5}', 'v'],
	['\u{1d5b6}', 'w'],
	['\u{1d5b7}', 'x'],
	['\u{1d5b8}', 'y'],
	['\u{1d5b9}', 'z'],
	['\u{1d5d4}', 'a'],
	['\u{1d5d5}', 'b'],
	['\u{1d5d6}', 'c'],
	['\u{1d5d7}', 'd'],
	['\u{1d5d8}', 'e'],
	['\u{1d5d9}', 'f'],
	['\u{1d5da}', 'g'],
	['\u{1d5db}', 'h'],
	['\u{1d5dc}', 'i'],
	['\u{1d5dd}', 'j'],
	['\u{1d5de}', 'k'],
	['\u{1d5df}', 'l'],
	['\u{1d5e0}', 'm'],
	['\u{1d5e1}', 'n'],
	['\u{1d5e2}', 'o'],
	['\u{1d5e3}', 'p'],
	['\u{1d5e4}', 'q'],
	['\u{1d5e5}', 'r'],
	['\u{1d5e6}', 's'],
	['\u{1d5e7}', 't'],
	['\u{1d5e8}', 'u'],
	['\u{1d5e9}', 'v'],
	['\u{1d5ea}', 'w'],
	['\u{1d5eb}', 'x'],
	['\u{1d5ec}', 'y'],
	['\u{1d5ed}', 'z'],
	['\u{1d608}', 'a'],
	['\u{1d609}', 'b'],
	['\u{1d60a}', 'c'],
	['\u{1d60b}', 'd'],
	['\u{1d60c}', 'e'],
	['\u{1d60d}', 'f'],
	['\u{1d60e}', 'g'],
	['\u{1d60f}', 'h'],
	['\u{1d610}', 'i'],
	['\u{1d611}', 'j'],
	['\u{1d612}', 'k'],
	['\u{1d613}', 'l'],
	['\u{1d614}', 'm'],
	['\u{1d615}', 'n'],
	['\u{1d616}', 'o'],
	['\u{1d617}', 'p'],
	['\u{1d618}', 'q'],
	['\u{1d619}', 'r'],
	['\u{1d61a}', 's'],
	['\u{1d61b}', 't'],
	['\u{1d61c}', 'u'],
	['\u{1d61d}', 'v'],
	['\u{1d61e}', 'w'],
	['\u{1d61f}', 'x'],
	['\u{1d620}', 'y'],
	['\u{1d621}', 'z'],
	['\u{1d63c}', 'a'],
	['\u{1d63d}', 'b'],
	['\u{1d63e}', 'c'],
	['\u{1d63f}', 'd'],
	['\u{1d640}', 'e'],
	['\u{1d641}', 'f'],
	['\u{1d642}', 'g'],
	['\u{1d643}', 'h'],
	['\u{1d644}', 'i'],
	['\u{1d645}', 'j'],
	['\u{1d646}', 'k'],
	['\u{1d647}', 'l'],
	['\u{1d648}', 'm'],
	['\u{1d649}', 'n'],
	['\u{1d64a}', 'o'],
	['\u{1d64b}', 'p'],
	['\u{1d64c}', 'q'],
	['\u{1d64d}', 'r'],
	['\u{1d64e}', 's'],
	['\u{1d64f}', 't'],
	['\u{1d650}', 'u'],
	['\u{1d651}', 'v'],
	['\u{1d652}', 'w'],
	['\u{1d653}', 'x'],
	['\u{1d654}', 'y'],
	['\u{1d655}', 'z'],
	['\u{1d670}', 'a'],
	['\u{1d671}', 'b'],
	['\u{1d672}', 'c'],
	['\u{1d673}', 'd'],
	['\u{1d674}', 'e'],
	['\u{1d675}', 'f'],
	['\u{1d676}', 'g'],
	['\u{1d677}', 'h'],
	['\u{1d678}', 'i'],
	['\u{1d679}', 'j'],
	['\u{1d67a}', 'k'],
	['\u{1d67b}', 'l'],
	['\u{1d67c}', 'm'],
	['\u{1d67d}', 'n'],
	['\u{1d67e}', 'o'],
	['\u{1d67f}', 'p'],
	['\u{1d680}', 'q'],
	['\u{1d681}', 'r'],
	['\u{1d682}', 's'],
	['\u{1d683}', 't'],
	['\u{1d684}', 'u'],
	['\u{1d685}', 'v'],
	['\u{1d686}', 'w'],
	['\u{1d687}', 'x'],
	['\u{1d688}', 'y'],
	['\u{1d689}', 'z'],
	['\u{1d6a8}', '\u03b1'],
	['\u{1d6a9}', '\u03b2'],
	['\u{1d6aa}', '\u03b3'],
	['\u{1d6ab}', '\u03b4'],
	['\u{1d6ac}', '\u03b5'],
	['\u{1d6ad}', '\u03b6'],
	['\u{1d6ae}', '\u03b7'],
	['\u{1d6af}', '\u03b8'],
	['\u{1d6b0}', '\u03b9'],
	['\u{1d6b1}', '\u03ba'],
	['\u{1d6b2}', '\u03bb'],
	['\u{1d6b3}', '\u03bc'],
	['\u{1d6b4}', '\u03bd'],
	['\u{1d6b5}', '\u03be'],
	['\u{1d6b6}', '\u03bf'],
	['\u{1d6b7}', '\u03c0'],
	['\u{1d6b8}', '\u03c1'],
	['\u{1d6b9}', '\u03b8'],
	['\u{1d6ba}', '\u03c3'],
	['\u{1d6bb}', '\u03c4'],
	['\u{1d6bc}', '\u03c5'],
	['\u{1d6bd}', '\u03c6'],
	['\u{1d6be}', '\u03c7'],
	['\u{1d6bf}', '\u03c8'],
	['\u{1d6c0}', '\u03c9'],
	['\u{1d6d3}', '\u03c3'],
	['\u{1d6e2}', '\u03b1'],
	['\u{1d6e3}', '\u03b2'],
	['\u{1d6e4}', '\u03b3'],
	['\u{1d6e5}', '\u03b4'],
	['\u{1d6e6}', '\u03b5'],
	['\u{1d6e7}', '\u03b6'],
	['\u{1d6e8}', '\u03b7'],
	['\u{1d6e9}', '\u03b8'],
	['\u{1d6ea}', '\u03b9'],
	['\u{1d6eb}', '\u03ba'],
	['\u{1d6ec}', '\u03bb'],
	['\u{1d6ed}', '\u03bc'],
	['\u{1d6ee}', '\u03bd'],
	['\u{1d6ef}', '\u03be'],
	['\u{1d6f0}', '\u03bf'],
	['\u{1d6f1}', '\u03c0'],
	['\u{1d6f2}', '\u03c1'],
	['\u{1d6f3}', '\u03b8'],
	['\u{1d6f4}', '\u03c3'],
	['\u{1d6f5}', '\u03c4'],
	['\u{1d6f6}', '\u03c5'],
	['\u{1d6f7}', '\u03c6'],
	['\u{1d6f8}', '\u03c7'],
	['\u{1d6f9}', '\u03c8'],
	['\u{1d6fa}', '\u03c9'],
	['\u{1d70d}', '\u03c3'],
	['\u{1d71c}', '\u03b1'],
	['\u{1d71d}', '\u03b2'],
	['\u{1d71e}', '\u03b3'],
	['\u{1d71f}', '\u03b4'],
	['\u{1d720}', '\u03b5'],
	['\u{1d721}', '\u03b6'],
	['\u{1d722}', '\u03b7'],
	['\u{1d723}', '\u03b8'],
	['\u{1d724}', '\u03b9'],
	['\u{1d725}', '\u03ba'],
	['\u{1d726}', '\u03bb'],
	['\u{1d727}', '\u03bc'],
	['\u{1d728}', '\u03bd'],
	['\u{1d729}', '\u03be'],
	['\u{1d72a}', '\u03bf'],
	['\u{1d72b}', '\u03c0'],
	['\u{1d72c}', '\u03c1'],
	['\u{1d72d}', '\u03b8'],
	['\u{1d72e}', '\u03c3'],
	['\u{1d72f}', '\u03c4'],
	['\u{1d730}', '\u03c5'],
	['\u{1d731}', '\u03c6'],
	['\u{1d732}', '\u03c7'],
	['\u{1d733}', '\u03c8'],
	['\u{1d734}', '\u03c9'],
	['\u{1d747}', '\u03c3'],
	['\u{1d756}', '\u03b1'],
	['\u{1d757}', '\u03b2'],
	['\u{1d758}', '\u03b3'],
	['\u{1d759}', '\u03b4'],
	['\u{1d75a}', '\u03b5'],
	['\u{1d75b}', '\u03b6'],
	['\u{1d75c}', '\u03b7'],
	['\u{1d75d}', '\u03b8'],
	['\u{1d75e}', '\u03b9'],
	['\u{1d75f}', '\u03ba'],
	['\u{1d760}', '\u03bb'],
	['\u{1d761}', '\u03bc'],
	['\u{1d762}', '\u03bd'],
	['\u{1d763}', '\u03be'],
	['\u{1d764}', '\u03bf'],
	['\u{1d765}', '\u03c0'],
	['\u{1d766}', '\u03c1'],
	['\u{1d767}', '\u03b8'],
	['\u{1d768}', '\u03c3'],
	['\u{1d769}', '\u03c4'],
	['\u{1d76a}', '\u03c5'],
	['\u{1d76b}', '\u03c6'],
	['\u{1d76c}', '\u03c7'],
	['\u{1d76d}', '\u03c8'],
	['\u{1d76e}', '\u03c9'],
	['\u{1d781}', '\u03c3'],
	['\u{1d790}', '\u03b1'],
	['\u{1d791}', '\u03b2'],
	['\u{1d792}', '\u03b3'],
	['\u{1d793}', '\u03b4'],
	['\u{1d794}', '\u03b5'],
	['\u{1d795}', '\u03b6'],
	['\u{1d796}', '\u03b7'],
	['\u{1d797}', '\u03b8'],
	['\u{1d798}', '\u03b9'],
	['\u{1d799}', '\u03ba'],
	['\u{1d79a}', '\u03bb'],
	['\u{1d79b}', '\u03bc'],
	['\u{1d79c}', '\u03bd'],
	['\u{1d79d}', '\u03be'],
	['\u{1d79e}', '\u03bf'],
	['\u{1d79f}', '\u03c0'],
	['\u{1d7a0}', '\u03c1'],
	['\u{1d7a1}', '\u03b8'],
	['\u{1d7a2}', '\u03c3'],
	['\u{1d7a3}', '\u03c4'],
	['\u{1d7a4}', '\u03c5'],
	['\u{1d7a5}', '\u03c6'],
	['\u{1d7a6}', '\u03c7'],
	['\u{1d7a7}', '\u03c8'],
	['\u{1d7a8}', '\u03c9'],
	['\u{1d7bb}', '\u03c3'],
]);

/**
 * CJK compatibility ideographs whose NFKC decomposition Unicode 4.0 corrected.
 * RFC 4518 is fixed to Unicode 3.2, so these are decomposed to their 3.2 target
 * before the host NFKC runs. U+F951's correction landed in Unicode 3.2 itself,
 * so it is not overridden.
 */
export const NFKC_3_2_CORRECTIONS: ReadonlyMap<string, string> = new Map<string, string>([
	['\u{2f868}', '\u{2136a}'],
	['\u{2f874}', '\u{5f33}'],
	['\u{2f91f}', '\u{43ab}'],
	['\u{2f95f}', '\u{7aae}'],
	['\u{2f9bf}', '\u{4d57}'],
]);
